module.exports = __webpack_public_path__ + "img/load.3ee89f3f.png";